import { render, staticRenderFns } from "./CreateScript.vue?vue&type=template&id=9447f980"
import script from "./CreateScript.vue?vue&type=script&lang=js"
export * from "./CreateScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports